import React from "react";
import CampaignWizard from "./CampaignWizard";

/**
 * Send Campaign Page
 * Delegates audience selection and campaign execution to the step-by-step Campaign Wizard.
 */
const SendCampaignPage = () => {
    return <CampaignWizard />;
};

export default SendCampaignPage;
